/*============================================================================
  (c) Copyright 2014 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart

  Ajaxify the add to cart experience and flip the button for inline confirmation,
  show the cart in a modal, or a 3D drawer.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajaxify plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizer.min.js
    - snippet/ajax-cart-template.liquid

  JQUERY API (c) Copyright 2009-2014 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
  Includes slight modifications to addItemFromForm.
==============================================================================*/

if ((typeof Shopify) === 'undefined') { Shopify = {}; }

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
}

/*============================================================================
  API Functions
  - Shopify.format money is defined in option_selection.js.
    If that file is not included, it is redefined here.
==============================================================================*/
if ( !Shopify.formatMoney ) {
  Shopify.formatMoney = function(cents, format) {
    var value = '',
        placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
        formatString = (format || this.money_format);

    if (typeof cents == 'string') {
      cents = cents.replace('.','');
    }

    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number/100.0).toFixed(precision);

      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';

      return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };
}


// QuickView
var quickViewProduct = null;


Shopify.onProduct = function(product) {
  quickViewProduct = product;
  var images = new Array();
  $.each(product.images, function(index, image){
    var extension = image.substr((~-image.lastIndexOf(".") >>> 0) + 1);
    var fileName = image.substr(0, (~-image.lastIndexOf(".") >>> 0) + 1);
    images[index]= {
      large : fileName + '_large' + extension,
      grande : fileName + '_grande' + extension,
      compact : fileName + '_compact' + extension,
    };
  });
  if(product.featured_image != null) {
  	var extension = product.featured_image.substr((~-product.featured_image.lastIndexOf(".") >>> 0) + 1);
    var fileName = product.featured_image.substr(0, (~-product.featured_image.lastIndexOf(".") >>> 0) + 1);
    product.featured_image_large = fileName + '_large' + extension;
    product.featured_image_grande = fileName + '_grande' + extension;
  }
  $.each(product.variants, function(index, variant){
    if(!variant.available) {
    	if(variant.inventory_quantity < 1 && variant.inventory_policy == 'continue') {
      		product.variants[index].preorder = true;
        } else {
	  		product.variants[index].soldout = true;
    	}
    }
  });

  var source   = $("#quickView").html(),
      template = Handlebars.compile(source),
      data = {
        product: product,
        images: images,
        
        vendorLabel: 'Brand:',
        vendor: product.vendor,
        
        price: Shopify.formatMoney(product.price, moneyFormat ),
        shouldCompare: product.compare_at_price_max > product.price,
        saveLabel: 'Save',
        saveAmount: Shopify.formatMoney(product.compare_at_price - product.price, moneyFormat ),
        comparePriceFull: Shopify.formatMoney(product.compare_at_price, moneyFormat ),
        addToCartLabel: 'Add to cart',
        soldLabel: 'Sold Out',
        
        quantityEnable: true,
        quantityLabel : 'Quantity',
        
        
        quantityLeft: true,
        
        
        saleTagOverImage: true,
        
        
        
        quickDesc: true,
        
        showCarousel: product.images.length > 4 ? true : false,
        lessImages: product.images.length < 5 ? true : false,
        moreImages: product.images.length > 1 ? true : false,
        
        countdownTag: true,
        countdownBeforeText : 'Discount ending in ',
        
      };
  
  /* swap old ordinary product option selection boxes for swatches */
  var importSwatches = function() {
    $.ajax({
      type: 'GET',
      url: product.url,
      data: {},
      complete: function(data) {
        
        $('.quick-cards').html($('.icons-box', data.responseText).html());
        // swatches
        var sw = jQuery('#grid-swatches-' + product.id).clone();
        
        jQuery('#addToCartForm-' + product.id).prepend(sw);
        
        
        jQuery('.product-data').animate({'opacity': 1});
        // first selected elements
        
        // Shopify.linkOptionSelectors removes unavailable options so we need to show them back in quick view
        jQuery('#addToCartForm-' + product.id + ' .swatch-element.soldout').show();
        jQuery('#addToCartForm-' + product.id + ' .swatch-image').first().trigger('click');
        
        
        product.tags.forEach(function(element) {
          if (element.startsWith('countdown')) {
            var sparts = element.split('-');
            jQuery('#product-countdown-' + product.id).show();
            jQuery('#productCountdown-' + product.id).attr('data-countdown', sparts[1]).show();
            var $this = jQuery('#productCountdown-' + product.id),
                finalDate = jQuery('#productCountdown-' + product.id).data('countdown');
            $this.countdown(finalDate, function(event) {
              $this.html(event.strftime('<span class="day-countdown">%-D day%!D</span> %Hh:%Mm:%Ss'));
              console.log(event.strftime('%D'));
              if ( event.strftime('%D') == '00') {
                $this.find($('span.day-countdown')).remove();
              }
              if ( event.strftime('%D') == '00' && event.strftime('%H') == '00' && event.strftime('%M') == '00' && event.strftime('%S') == '00' ) {
                  $('#product-countdown-' + product.id).remove();
              }
            });
          }
        });
        

        // set proper description, chosen in theme customizer
        
        
        
        $('.quick-description').html(product.description.substring(0, 300) + '&hellip;');
        
      }
    });
  }

  /* open popup */
  $.magnificPopup.open({
    removalDelay: 500,
    items: {
      src: template(data),
      type: 'inline'
    },
    callbacks: {
      beforeOpen: function() {
        this.st.mainClass = 'mfp-zoom-out';
      },
      open: function() {
        jQuery('#productPrice-'+product.id).find('span.money').each(function() {
          jQuery(this).attr('data-currency-'+shopCurrency, jQuery(this).html());
        });
        jQuery('#comparePrice-'+product.id).find('span.money').each(function() {
          jQuery(this).attr('data-currency-'+shopCurrency, jQuery(this).html());
        });
        
        // swap product options with swatches
        importSwatches();
      },
    },
  });

  if(product.options.length > 0) {
    new Shopify.OptionSelectors('productSelect-'+product.id, {
      product: product,
      onVariantSelected: Shopify.quickViewVariantSelected,
      enableHistoryState: true
    });
    if(product.options.length == 1) {
      if( (product.options[0].name == 'Title') && (product.variants[0].title == 'Default Title') ) {
        $('#productSelect-'+product.id+'-option-0').hide();
        $('#grid-swatches-' + product.id + ' .swatch').hide();
      } else {
        $('.selector-wrapper:eq(0)').prepend('<label>' + product.options[0].name + '</label>');
      }
    }
  } else {
    jQuery('#productSelect-'+product.id).hide();
  }

  $("#owl-featured-thumbs-"+product.id).owlCarousel({
    nav:true,
    navText:[,],
    lazyLoad:true,
    navRewind: false,
    margin:30,
    responsive:{
      0:{
        items: 4,
        nav: true,
      },
      480:{
        items: 4,
        nav: true,
      },    
      768:{
        items: 4,
        nav: true,
      },
      920:{
        items: 4,
        nav: true,
      }
    }
  });
};

// QuickView
Shopify.quickViewVariantSelected = function(variant, selector) {

  $.each(selector.selectors, function(index, value) {
    if(typeof value.name == 'object') {
      var name = value.name.name;
      var id = $(value.element).attr('id');
      $('label[for="'+id+'"]').html(name);
    }
  });
  
  var productId = selector.product.id,
      $addToCart = $('#addToCart-'+productId),
      $productPrice = $('#productPrice-'+productId),
      $comparePrice = $('#comparePrice-'+productId),
      $comparePriceFull = $('#comparePriceFull-'+productId),
      $quantityElements = $('#addToCartForm-'+productId+' .quantity-selector, #addToCartForm-'+productId+' .js-qty'),
      $addToCartText = $('#addToCartText-'+productId),
      $variantQuantity = $('#variantQuantity-'+productId),
      $featuredImage = $('#productPhotoImg-'+productId);

    if (variant) {
      // Update variant image, if one is set
      // Call timber.switchImage function in shop.js
      var featuredImage = selector.product.featured_image;
      if (variant.featured_image) {
        featuredImage = variant.featured_image;
        var newImg = featuredImage,
            el = $featuredImage[0];
        Shopify.Image.switchImage(featuredImage, el);
      } else {
        $featuredImage.attr('src', $featuredImage.data('original'));
      }

      var form = jQuery('#' + selector.domIdPrefix).closest('form');
      for (var i=0, length = variant.options.length; i < length; i++) {
        var radioButton = form.find('.swatch[data-option-index="' + i + '"] :radio[value="' + variant.options[i] +'"]');
        if (radioButton.length) {
          radioButton.get(0).checked = true;
        }
      }

      if (variant.inventory_management == 'shopify') {
        if (variant.inventory_quantity > 0 || variant.inventory_policy == 'continue') {
          // We have a valid product variant, so enable the Add to cart button
          $addToCart.removeClass('disabled').prop('disabled', false);
          $addToCartText.text("Add to cart");
        }

        if (variant.inventory_quantity < 1 && variant.inventory_policy == 'continue'){
          // Inventory is zero for this variant but we want to allow purchase, so show Pre-order button
          $addToCartText.text("Pre-order");
        }  

        if (variant.inventory_quantity < 1 && variant.inventory_policy != 'continue') {
          // Variant is sold out, disable the submit button
          $addToCart.addClass('disabled').prop('disabled', true);
          $addToCartText.text("Sold Out");
          $variantQuantity.hide();
          $quantityElements.hide();
        }

      } else {
        // We have set No tracking of inventory
        $addToCart.removeClass('disabled').prop('disabled', false);
        $addToCartText.text("Add to cart");

      }

      // Show how many items are left, if below 10
      if (variant.inventory_management && variant.inventory_policy != 'continue') {
        if (variant.inventory_quantity < 10 && variant.inventory_quantity > 0) {
          $variantQuantity.html("Hurry, only" + ' ' + variant.inventory_quantity + ' ' + "item(s) left!").show();
        } else {
          $variantQuantity.hide();
        }
      }

      $quantityElements.show();

      // Regardless of stock, update the product price
      var customPriceFormat= Shopify.formatMoney(variant.price, moneyFormat);
      $productPrice.html(customPriceFormat);

      

      // Also update and show the product's compare price if necessary
      if ( variant.compare_at_price > variant.price ) {
        var priceSaving = timber.formatSaleTag( Shopify.formatMoney(variant.compare_at_price - variant.price, moneyFormat) );
        $comparePrice.html("Save" + ' ' + priceSaving).show();
        var comparePriceFull = timber.formatSaleTag( Shopify.formatMoney(variant.compare_at_price, moneyFormat) );
        $comparePriceFull.html(comparePriceFull).show();
        
      } else {
        $comparePrice.hide();
        $comparePriceFull.hide();
      }

    } else {
      // The variant doesn't exist, disable submit button.
      // This may be an error or notice that a specific variant is not available.
      $addToCart.addClass('disabled').prop('disabled', true);
      $addToCartText.text("Unavailable");
      $quantityElements.hide();
      $variantQuantity.hide();
    }
  
};




Shopify.onCartUpdate = function(cart) {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
};

Shopify.updateCartNote = function(note, callback) {
  var params = {
    type: 'POST',
    url: '/cart/update.js',
    data: 'note=' + attributeToString(note),
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      } else {
        Shopify.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      Shopify.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

Shopify.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    alert(data.message + '(' + data.status  + '): ' + data.description);
  } else {
    alert('Error : ' + Shopify.fullMessagesFromErrors(data).join('; ') + '.');
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the line item associated with the added item
==============================================================================*/
Shopify.addItem = function(variant_id, quantity, callback, errorCallback) {
  var quantity = quantity || 1;
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: 'quantity=' + quantity + '&id=' + variant_id,
    dataType: 'json',
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      if ((typeof errorCallback) === 'function') {
      	errorCallback(XMLHttpRequest, textStatus, variant_id);
      }
    }
  };
  jQuery.ajax(params);
};

/*============================================================================
  POST to cart/add.js returns the JSON of the line item
    - Allow use of form element instead of id
    - Allow custom error callback
==============================================================================*/
Shopify.addItemFromForm = function(form, callback, errorCallback) {
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: jQuery(form).serialize(),
    dataType: 'json',
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item, form);
      } else {
        Shopify.onItemAdded(line_item, form);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      if ((typeof errorCallback) === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      } else {
        Shopify.onError(XMLHttpRequest, textStatus);
      }
    }
  };
  jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
Shopify.getCart = function(callback) {
  jQuery.getJSON('/cart.js', function (cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart);
    } else {
      Shopify.onCartUpdate(cart);
    }
  });
};

// GET products/<product-handle>.js returns the product in JSON
Shopify.getProduct = function(handle, callback) {
  jQuery.getJSON('/products/' + handle + '.js', function (product, textStatus) {
    if ((typeof callback) === 'function') {
      callback(product);
    } else {
      Shopify.onProduct(product);
    }
  });
};

// POST to cart/change.js returns the cart in JSON
Shopify.changeItem = function(variant_id, quantity, callback) {
  var params = {
    type: 'POST',
    url: '/cart/change.js',
    data:  'quantity='+quantity+'&id='+variant_id,
    dataType: 'json',
    success: function(cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      } else {
        Shopify.onCartUpdate(cart);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      Shopify.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

/*============================================================================
  Ajaxify Shopify Add To Cart
==============================================================================*/
var ajaxifyShopify = (function(module, $) {

  'use strict';

  // Public functions
  var init;

  // Private general variables
  var settings, cartInit, $drawerHeight, $cssTransforms, $cssTransforms3d, $nojQueryLoad, $w, $body, $html;

  // Private plugin variables
  var $formContainer, $btnClass, $wrapperClass, $addToCart, $flipClose, $flipCart, $flipContainer, $cartCountSelector, $cartCostSelector, $toggleCartButton, $modal, $cartContainer, $drawerCaret, $modalContainer, $modalOverlay, $closeCart, $drawerContainer, $prependDrawerTo, $callbackData={};

  // Private functions
  var updateCountPrice, flipSetup, revertFlipButton, modalSetup, showModal, sizeModal, hideModal, drawerFixing, drawerSetup, showDrawer, hideDrawer, loadCartImages, itemAddedCallback, itemErrorCallback, cartUpdateCallback, setToggleButtons, flipCartUpdateCallback, buildCart, cartTemplate, adjustCart, adjustCartCallback, createQtySelectors, qtySelectors, scrollTop, toggleCallback;

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function (options) {

    // Default settings
    settings = {
      method: 'drawer', // Method options are drawer, modal, and flip. Default is drawer.
      formSelector: 'form[action^="/cart/add"]',
      addToCartSelector: 'input[type="submit"]',
      cartCountSelector: null,
      cartCostSelector: null,
      toggleCartButton: null,
      btnClass: null,
      wrapperClass: null,
      useCartTemplate: false,
      moneyFormat: '$',
      disableAjaxCart: false,
      enableQtySelectors: true,
      prependDrawerTo: '#quick-cart',
      onToggleCallback: null
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // Make sure method is lower case
    settings.method = settings.method.toLowerCase();

    // Select DOM elements
    $formContainer     = $(settings.formSelector);
    $btnClass          = settings.btnClass;
    $wrapperClass      = settings.wrapperClass;
    $addToCart         = $formContainer.find(settings.addToCartSelector);
    $flipContainer     = null;
    $flipClose         = null;
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector  = $(settings.cartCostSelector);
    $toggleCartButton  = $(settings.toggleCartButton);
    $modal             = null;
    $prependDrawerTo   = $(settings.prependDrawerTo);

    // CSS Checks
    $cssTransforms   = Modernizr.csstransforms;
    $cssTransforms3d = Modernizr.csstransforms3d;

    // General Selectors
    $w    = $(window);
    $body = $('body');
    $html = $('html');

    // QuickView image switch
    $(document).on('click', '.quick-view .thumbs img', function(){
      	$(this).parents('.quick-view').find('.featured-image img').attr('src', $(this).data('image'));
    });

      
    $(document).on('submit', 'form.add-to-cart-form', function(e) {
      e.preventDefault();

      // Add class to be styled if desired
      //$addToCart.removeClass('is-added').addClass('is-adding');

      Shopify.addItemFromForm(e.target, itemAddedCallback, itemErrorCallback);
    });
    

    // Check if we can use .load
    $nojQueryLoad = $html.hasClass('lt-ie9');
    if ($nojQueryLoad) {
      settings.useCartTemplate = false;
    }

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      qtySelectors();
    }

    // Enable the ajax cart
    if (!settings.disableAjaxCart) {
      // Handle each case add to cart method
      switch (settings.method) {
        case 'flip':
          flipSetup();
          break;

        case 'modal':
          modalSetup();
          break;

        case 'drawer':
          drawerSetup();
          break;
      }

      // Escape key closes cart
      $(document).keyup( function (evt) {
        if (evt.keyCode == 27) {
          switch (settings.method) {
            case 'flip':
            case 'drawer':
              hideDrawer();
              break;
            case 'modal':
              hideModal();
              break;
          }
        }
      });
      
      $('body').click(function() {
        switch (settings.method) {
          case 'flip':
          case 'drawer':
            hideDrawer();
            break;
          case 'modal':
            hideModal();
            break;
        }
      });

      $('a[data-rel="add-to-cart"]').click(function(event){
      	event.preventDefault();
        Shopify.addItem($(this).data('variant-id'), 1, itemAddedCallback, itemErrorCallback);
      });
    }
    
    $(document).on('click', '[data-rel="quick-view"]', function(event){
      event.preventDefault();
      Shopify.getProduct($(this).data('handle'));
    });

    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart();
  };

  updateCountPrice = function (cart) {
    if ($cartCountSelector) {
      $cartCountSelector.html(cart.item_count + '<i>' + (cart.item_count == 1 ? ' Item' : ' Items') + '</i>').removeClass('hidden-count');
      
      if (cart.item_count === 0) {
        $cartCountSelector.addClass('hidden-count');
      }
    }
    if ($cartCostSelector) {
        var totalPrice = timber.formatSaleTag( Shopify.formatMoney(cart.total_price, moneyFormat) );
        $cartCostSelector.html(totalPrice);
        
    }
  };

  flipSetup = function () {
    // Build and append the drawer in the DOM
    drawerSetup();
  };

  modalSetup = function () {
    // Create modal DOM elements with handlebars.js template
    var source   = $("#modalTemplate").html(),
        template = Handlebars.compile(source);

    // Append modal and overlay to body
    $body.append(template).append('<div id="ajaxifyCart-overlay"></div>');

    // Modal selectors
    $modalContainer = $('#ajaxifyModal');
    $modalOverlay   = $('#ajaxifyCart-overlay');
    $cartContainer  = $('#ajaxifyCart');

    // Close modal when clicking the overlay
    $modalOverlay.on('click', hideModal);

    // Create a close modal button
    $modalContainer.prepend('<button class="ajaxifyCart--close" title="Close Cart">Close Cart</button>');
    $closeCart = $('.ajaxifyCart--close');
    $closeCart.on('click', hideModal);

    // Add a class if CSS translate isn't available
    if (!$cssTransforms) {
      $modalContainer.addClass('no-transforms')
    }

    // Update modal position on screen changes
    $(window).on({
      orientationchange: function(e) {
        if ($modalContainer.hasClass('is-visible')) {
          sizeModal('resize');
        }
      }, resize: function(e) {
        // IE8 fires this when overflow on body is changed. Ignore IE8.
        if (!$nojQueryLoad && $modalContainer.hasClass('is-visible')) {
          sizeModal('resize');
        }
      }
    });

    // Toggle modal with cart button
    setToggleButtons();
  };

  showModal = function (toggle) {
    $body.addClass('ajaxify-modal--visible');
    // Build the cart if it isn't already there
    if ( !cartInit && toggle ) {
      Shopify.getCart(cartUpdateCallback);
    } else {
      sizeModal();
    }
  };

  sizeModal = function(isResizing) {
    if (!isResizing) {
      $modalContainer.css('opacity', 0);
    }

    // Position modal by negative margin
    $modalContainer.css({
      'margin-left': - ($modalContainer.outerWidth() / 2),
      'opacity': 1
    });

    // Position close button relative to title
    $closeCart.css({
      'top': 10 + ( $cartContainer.find('h1').height() / 2 )
    })

    $modalContainer.addClass('is-visible');

    //scrollTop();

    toggleCallback({
      'is_visible': true
    });
  };

  hideModal = function (e) {
    $body.removeClass('ajaxify-modal--visible');
    if (e) {
      e.preventDefault();
    }

    if ($modalContainer) {
      $modalContainer.removeClass('is-visible');
      $body.removeClass('ajaxify-lock');
    }

    toggleCallback({
      'is_visible': false
    });
  };

  drawerSetup = function () {
    // Create drawer DOM elements with handlebars.js template
    var source   = $("#drawerTemplate").html(),
        template = Handlebars.compile(source),
        data = {
          wrapperClass: $wrapperClass
        };

    // Append drawer (defaults to body)
    $prependDrawerTo.prepend(template(data));

    // Drawer selectors
    $drawerContainer = $('#ajaxifyDrawer');
    $cartContainer   = $('#ajaxifyCart');
    $drawerCaret     = $('.ajaxifyDrawer-caret > span');

    // Toggle drawer with cart button
    setToggleButtons();

    // Position caret and size drawer on resize if drawer is visible
    var timeout;
    $(window).resize(function() {
      clearTimeout(timeout);
      timeout = setTimeout(function(){
        if ($drawerContainer.hasClass('is-visible')) {
          positionCaret();
        }
      }, 500);
    });

    // Position the caret the first time
    positionCaret();

    // Position the caret
    function positionCaret() {
      if ($toggleCartButton.offset()) {
        // Get the position of the toggle button to align the carat with
        var togglePos = $toggleCartButton.offset(),
            toggleWidth = $toggleCartButton.outerWidth(),
            toggleMiddle = togglePos.left + toggleWidth/2;

        $drawerCaret.css('left', toggleMiddle + 'px');
      }
    }
    
    $drawerContainer.click(function(e) {
      e.stopPropagation();
    });
  };

  drawerFixing = function () {
    if( $('body').hasClass('sticky-move') ) {
      $drawerContainer.addClass('fixed-drawer');
      var wW = $(window).width(),
          nW = $('.site-header > .wrapper').width(),
          nh = $('.navbar > .wrapper').height();
      $('.fixed-drawer').css({
        'top': nh,
        'right': (wW - nW) / 2,
      });
    }
  }

  showDrawer = function (toggle) {
    // If we're toggling with the flip method, use a special callback
    if (settings.method == 'flip') {
      Shopify.getCart(flipCartUpdateCallback);
    }
    // opening the drawer for the first time
    else if ( !cartInit && toggle) {
      Shopify.getCart(cartUpdateCallback);
    }

    // Show the drawer
    $drawerContainer.addClass('is-visible');
    
    drawerFixing();

    //scrollTop();

    toggleCallback({
      'is_visible': true
    });
  };

  hideDrawer = function () {
    $drawerContainer.removeAttr('style').removeClass('is-visible');
    //scrollTop();
    toggleCallback({
      'is_visible': false
    });
  };


  loadCartImages = function () {
    // Size cart once all images are loaded
    var cartImages = $('img', $cartContainer),
        count = cartImages.length,
        index = 0;

    cartImages.on('load', function() {
      index++;

      if (index==count) {
        switch (settings.method) {
          case 'modal':
            sizeModal();
            break;
          case 'flip':
          case 'drawer':
            break;
        }
      }
    });
  };

  itemAddedCallback = function (product) {
    if($flipContainer != null) {
    	$flipContainer.removeClass('flip--is-loading');
    }
    $addToCart.removeClass('is-adding').addClass('is-added');
    var source   = $("#ajaxifyAddedToCart").html(),
        template = Handlebars.compile(source),
        data = {
          title : product.product_title,
          viewCartLabel : 'View Cart',
          addedToCart : 'added to your cart!',
          addedOr : 'or',
          continueLabel : 'Continue Shopping',
        };

    
    // Append new quantity selector then remove original
    $.magnificPopup.open({
      removalDelay: 500,
      items: {
        src: template(data),
        type: 'inline'
      },
      callbacks: {
    	beforeOpen: function() {
       		this.st.mainClass = 'mfp-zoom-out';
    	},
      }

      // You may add options here, they're exactly the same as for $.fn.magnificPopup call
      // Note that some settings that rely on click event (like disableOn or midClick) will not work here
    }, 0);
    
    Shopify.getCart(cartUpdateCallback);
  };

  itemErrorCallback = function (XMLHttpRequest, textStatus, variant_id) {
    if($flipContainer != null) {
    	$flipContainer.removeClass('flip--is-loading');
    }
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    if (!!data.message) {
      if (data.status == 422) {
        var source   = $("#ajaxifyCartError").html(),
            template = Handlebars.compile(source),
            data = {
              message : data.description
            };

        $.magnificPopup.open({
          removalDelay: 500,
          items: {
            src: template(data),
            type: 'inline'
          },
          callbacks: {
            beforeOpen: function() {
                this.st.mainClass = 'mfp-zoom-out';
            },
          }
          // You may add options here, they're exactly the same as for $.fn.magnificPopup call
          // Note that some settings that rely on click event (like disableOn or midClick) will not work here
        }, 0);
      }
    }
  };

  cartUpdateCallback = function (cart) {
    // Update quantity and price
    if (settings.method == 'flip') {
      Shopify.getCart(flipCartUpdateCallback);
    }
    // opening the drawer for the first time
    else if ( !cartInit ) {
      Shopify.getCart(cartUpdateCallback);
      cartInit = true;// dodato zbog infinite loopa inicijalizacije karta
    }
    updateCountPrice(cart);

    switch (settings.method) {
      case 'flip':
        $('.flip-cart span').html(cart.item_count);
        break;
      case 'modal':
        buildCart(cart);
        break;
      case 'drawer':
        buildCart(cart);
        /*if ( !$drawerContainer.hasClass('is-visible') ) {
          showDrawer();
        } else {
          scrollTop();
        }*/
        break;
    }
  };

  setToggleButtons = function () {
    // Reselect the element in case it just loaded
    $toggleCartButton  = $(settings.toggleCartButton);

    if ($toggleCartButton) {
      // Turn it off by default, in case it's initialized twice
      $toggleCartButton.off('click');

      // Toggle the cart, based on the method
      $toggleCartButton.on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        switch (settings.method) {
          case 'modal':
            if ( $modalContainer.hasClass('is-visible') ) {
              hideModal();
            } else {
              showModal(true);
            }
            break;
          case 'flip':
          case 'drawer':
            if ( $drawerContainer.hasClass('is-visible') ) {
              hideDrawer();
            } else {
              showDrawer(true);
            }
            break;
        }
      });
    }
  };

  flipCartUpdateCallback = function (cart) {
    buildCart(cart);
  };

  buildCart = function (cart) {
    // Empty cart if using default layout or not using the .load method to get /cart
    if (!settings.useCartTemplate || cart.item_count === 0) {
      $cartContainer.empty();
    }

    // Show empty cart
    if (cart.item_count === 0) {
      $cartContainer.append('<div class="empty-cart"><h2>Your cart is empty</h2><span>Continue browsing <a href="/collections/all">here</a>.</span></div>');

      switch (settings.method) {
        case 'modal':
          sizeModal('resize');
          break;
        case 'flip':
        case 'drawer':
          break;
      }
      return;
    }

    // Use the /cart template, or Handlebars.js layout based on theme settings
//    if (settings.useCartTemplate) {
//      cartTemplate(cart);
//      return;
//    }

    // Handlebars.js cart layout
    var items = [],
        item = {},
        data = {};

    var source   = $("#cartTemplate").html(),
        template = Handlebars.compile(source);

    // Add each item to our handlebars.js data
    $.each(cart.items, function(index, cartItem) {

      var itemAdd = cartItem.quantity + 1,
          itemMinus = cartItem.quantity - 1,
          itemQty = cartItem.quantity + ' x';

      /* Hack to get product image thumbnail
       *   - Remove file extension, add _small, and re-add extension
       *   - Create server relative link
      */
      var prodImg = cartItem.image == null ? '' : cartItem.image.replace(/(\.[^.]*)$/, "_small$1").replace('http:', '');
      var prodName = cartItem.title.replace(/(\-[^-]*)$/, "");
      var prodVariation = cartItem.title.replace(/^[^\-]*/, "").replace(/-/, "");

      // Create item's data object and add to 'items' array
      item = {
        id: cartItem.variant_id,
        url: cartItem.url,
        img: prodImg,
        name: prodName,
        variation: prodVariation,
        itemAdd: itemAdd,
        itemMinus: itemMinus,
        itemQty: itemQty,
        price: Shopify.formatMoney(cartItem.price, settings.moneyFormat),
        removeLabel: 'Remove',
      };

      items.push(item);
    });

    // Gather all cart data and add to DOM
    data = {
      items: items,
      totalPrice: Shopify.formatMoney(cart.total_price, settings.moneyFormat),
      btnClass: $btnClass,
      subtotalTitle: 'Subtotal',
      checkoutLabel: 'Checkout',
      viewBtn: 'Go to Cart',
    }
    $cartContainer.html(template(data));
    

    // With new elements we need to relink the adjust cart functions
    adjustCart();

    // Setup close modal button and size drawer
    switch (settings.method) {
      case 'modal':
        loadCartImages();
        break;
      case 'flip':
      case 'drawer':
        if (cart.item_count > 0) {
          loadCartImages();
        }
        break;
      default:
        break;
    }

    // Mark the cart as built
    cartInit = true;
  };

  cartTemplate = function (cart) {
    $cartContainer.load('/cart form[action="/cart"]', function() {

      // With new elements we need to relink the adjust cart functions
      adjustCart();

      // Size drawer at this point
      switch (settings.method) {
        case 'modal':
          loadCartImages();
          break;
        case 'flip':
        case 'drawer':
          if (cart.item_count > 0) {
            loadCartImages();
          }
          break;
        default:
          break;
      }

      // Mark the cart as built
      cartInit = true;
    });
  }

  adjustCart = function () {
    // This function runs on load, and when the cart is reprinted

    // Create ajax friendly quantity fields and remove links in the ajax cart
    if (settings.useCartTemplate) {
      createQtySelectors();
    }

    // Update quantify selectors
    var qtyAdjust = $('.ajaxifyCart--qty span');

    // Add or remove from the quantity
    qtyAdjust.off('click');
    qtyAdjust.on('click', function() {
      var el = $(this),
          id = el.data('id'),
          qtySelector = el.siblings('.ajaxifyCart--num'),
          qty = parseInt( qtySelector.val() );

      // Add or subtract from the current quantity
      if (el.hasClass('ajaxifyCart--add')) {
        qty = qty + 1;
      } else {
        qty = qty - 1;
        if (qty <= 0) qty = 0;
      }

      // If it has a data-id, update the cart.
      // Otherwise, just update the input's number
      if (id) {
        updateQuantity(id, qty);
      } else {
        qtySelector.val(qty);
      }

    });

    // Update quantity based on input on change
    var qtyInput = $('.ajaxifyCart--num');
    qtyInput.off('change');
    qtyInput.on('change', function() {
      var el = $(this),
          id = el.data('id'),
          qty = el.val();

      // Make sure we have a valid integer
      if( (parseFloat(qty) == parseInt(qty)) && !isNaN(qty) ) {
        // We have a number!
      } else {
        // Not a number. Default to 1.
        el.val(1);
        return;
      }

      // Only update the cart via ajax if we have a variant ID to work with
      if (id) {
        updateQuantity(id, qty);
      }
    });

    // Highlight the text when focused
    qtyInput.off('focus');
    qtyInput.on('focus', function() {
      var el = $(this);
      setTimeout(function() {
        el.select();
      }, 50);
    });

    // Completely remove product
    $('.ajaxifyCart--remove').on('click', function(e) {
      var el = $(this),
          id = el.data('id') || null,
          qty = 0;

      // Without an id, let the default link action take over
      if (!id) {
        return;
      }

      e.preventDefault();
      updateQuantity(id, qty);
    });

    function updateQuantity(id, qty) {
      // Add activity classes when changing cart quantities
      if (!settings.useCartTemplate) {
        var row = $('.ajaxifyCart--row[data-id="' + id + '"]').addClass('ajaxifyCart--is-loading');
      } else {
        var row = $('.cart-row[data-id="' + id + '"]').addClass('ajaxifyCart--is-loading');
      }

      if ( qty === 0 ) {
        row.addClass('is-removed');
      }

      // Slight delay to make sure removed animation is done
      setTimeout(function() {
        Shopify.changeItem(id, qty, adjustCartCallback);
      }, 250);
    }

    // Save note anytime it's changed
    var noteArea = $('textarea[name="note"]');
    noteArea.off('change');
    noteArea.on('change', function() {
      var newNote = $(this).val();

      // Simply updating the cart note in case they don't click update/checkout
      Shopify.updateCartNote(newNote, function(cart) {});
    });
  };

  adjustCartCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);

    // Hide the modal or drawer if we're at 0 items
    if ( cart.item_count === 0 ) {
      // Handle each add to cart method
      switch (settings.method) {
        case 'modal':
          break;
        case 'flip':
        case 'drawer':
          hideDrawer();
          break;
      }
    }

    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function() {
      Shopify.getCart(buildCart);
    }, 150)
  };

  createQtySelectors = function() {
    // If there is a normal quantity number field in the ajax cart, replace it with our version
    if ($('input[type="number"]', $cartContainer).length) {
      $('input[type="number"]', $cartContainer).each(function() {
        var el = $(this),
            currentQty = el.val();

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty + ' x';

        var source   = $("#ajaxifyQty").html(),
            template = Handlebars.compile(source),
            data = {
              id: el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus
            };

        // Append new quantity selector then remove original
        el.after(template(data)).remove();
      });
    }

    // If there is a regular link to remove an item, add attributes needed to ajaxify it
    if ($('a[href^="/cart/change"]', $cartContainer).length) {
      $('a[href^="/cart/change"]', $cartContainer).each(function() {
        var el = $(this).addClass('ajaxifyCart--remove');
      });
    }
  };

  qtySelectors = function() {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    var numInputs = $('input[type="number"]');

    if (numInputs.length) {
      numInputs.each(function() {
        var el = $(this),
            currentQty = el.val(),
            inputName = el.attr('name'),
            inputId = el.attr('id');

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#jsQty").html(),
            template = Handlebars.compile(source),
            data = {
              id: el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus,
              inputName: inputName,
              inputId: inputId
            };

        // Append new quantity selector then remove original
        el.after(template(data)).remove();
      });
    }
    // Setup listeners to add/subtract from the input
    $(document).on('click', '.js--qty-adjuster', function() {
      var el = $(this),
          id = el.data('id'),
          qtySelector = el.siblings('.js--num'),
          qty = parseInt( qtySelector.val() );

      // Add or subtract from the current quantity
      if (el.hasClass('js--add')) {
        qty = qty + 1;
      } else {
        qty = qty - 1;
        if (qty <= 1) qty = 1;
      }

      // Update the input's number
      qtySelector.val(qty);
    });

  };

  scrollTop = function () {
    if ($body.scrollTop() > 0 || $html.scrollTop() > 0) {
      $('html, body').animate({
        scrollTop: 0
      }, 250, 'swing');
    }
  };

  toggleCallback = function (data) {
    // Run the callback if it's a function
    if (typeof settings.onToggleCallback == 'function') {
      settings.onToggleCallback.call(this, data);
    }
  };

  module = {
    init: init
  };

  return module;

}(ajaxifyShopify || {}, jQuery));
